import { render, staticRenderFns } from "./UserFollowSubscribeModal.vue?vue&type=template&id=1d74e720&"
import script from "./UserFollowSubscribeModal.vue?vue&type=script&lang=ts&"
export * from "./UserFollowSubscribeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports